import React from 'react'
import '../scss/variables.scss'
import '../scss/reset.scss'
import './Create.scss'
import NavbarArrow from '../components/NavbarArrow/NavbarArrow'
import Footer from '../components/Footer/Footer'
import Sidemenu from '../components/Sidemenu/Sidemenu'

import copyIcon from '../assets/images/copyIcon.svg'

class Create extends React.Component {

    componentDidMount() {
        document.getElementById("createBottone").addEventListener('click', () => {
            /* Generate Link */
            // let crypto = require("crypto");
            // let id = crypto.randomBytes(5).toString('hex');
            var uuid = require("uuid");
            var id = uuid.v4();
            let link = "https://meet.jit.si/Fadymeet/" + id;
            document.getElementById("linkCode").innerHTML = link

            /* Show button and append the link */
            document.getElementById("joinButtonLink").style.display = 'block';
            document.getElementById("joinButtonLink").href = link;
        });

        /* Copy the link to the clipboard */
        document.querySelector(".iconPart").addEventListener('click', () => {
            var copyText = document.getElementById("linkCode");
            copyText.select();
            document.execCommand("copy");
        });
    }

    render() {
        let arrowPath = "/stanze";

        return (
            <>
                <Sidemenu path1="/chi-siamo" name1="Chi Siamo" path2="/progetto" name2="Il Progetto" path3="/supportaci" name3="Supportaci" path4="/community" name4="Community" />
                <NavbarArrow arrowPath={arrowPath} />
                <main className="mainCreate">
                    <h1>Crea la <br />tua stanza</h1>
                    <p className="createDescription">Premi su CREA, per poter generare 
                    la tua stanza privata da 
                    condividere con i tuoi amici!</p>
                    <button id="createBottone">CREA</button>
                    <div className="linkContainer">
                        <div className="iconPart">
                            <img src={copyIcon} alt="" />
                        </div>
                        <div className="linkPart">
                            {/* <p id="linkCode"></p> */}
                            <textarea name="link" id="linkCode"></textarea>
                        </div>
                    </div>
            
                    <a href="/create" id="joinButtonLink">
                        <button id="joinButton">ENTRA</button>
                    </a>
                </main>
                <Footer />
            </>
        )
    }

    
}

export default Create
